import React from "react";
import "./reparaciones.css";
import { motion } from "framer-motion";
import { animationVariants } from "../../constants/animationVariants";

const data = [
  {
    tipo: "Diagnostico/Revisión",
    sistemas: "PC-Notebook-AIO",
    freelance: 5533,
    local: 8019,
  },
  {
    tipo: "Formateo e instalación de Sistemas Operativos sin Back Up",
    sistemas: "PC-Notebook-AIO",
    freelance: 25083,
    local: 28868,
  },
  {
    tipo: "Limpieza de Hardware + Formateo e instalación de Sistema Operativo + Programas Básicos + Back up hasta 100gb + (Cambio a SSD)",
    sistemas: "PC-Notebook-AIO",
    freelance: 26559,
    local: 33680,
  },
  {
    tipo: "Back Up de datos cada 100gb Extras",
    sistemas: "PC-Notebook-AIO",
    freelance: 1844,
    local: 6415,
  },
  {
    tipo: "Inicialización de equipo nuevo (configuración + Programas Básicos)",
    sistemas: "PC-Notebook-AIO",
    freelance: 25083,
    local: 28868,
  },
  {
    tipo: "Instalación de Programas Open Source x1",
    sistemas: "PC-Notebook-AIO",
    freelance: 9522,
    local: 11227,
  },
  {
    tipo: "Instalación Programas Comerciales x1 provisto",
    sistemas: "PC-Notebook-AIO",
    freelance: 11066,
    local: 14434,
  },
  {
    tipo: "Instalación y configuración de Drivers",
    sistemas: "PC-Notebook-AIO",
    freelance: 9222,
    local: 11227,
  },
  {
    tipo: "Eliminación de Malware",
    sistemas: "PC-Notebook-AIO",
    freelance: 14386,
    local: 19246,
  },
  {
    tipo: "Conexión remota x 1hs - Problemas generales",
    sistemas: "PC-Notebook-AIO",
    freelance: 7377,
    local: 9623,
  },
  {
    tipo: "Visita a domicilio x 1hs",
    sistemas: "PC-Notebook-AIO",
    freelance: 14755,
    local: 19246,
  },
  {
    tipo: "Visita a domicilio x 1hs Emergencia Fuera de HS",
    sistemas: "PC-Notebook-AIO",
    freelance: 22132,
    local: 24057,
  },
  {
    tipo: "Clonado de disco sin errores SMART",
    sistemas: "PC-Notebook-AIO",
    freelance: 20288,
    local: 22453,
  },
  {
    tipo: "Clonado de disco con errores SMART",
    sistemas: "PC-Notebook-AIO",
    freelance: 25821,
    local: 32076,
  },
  {
    tipo: "Reparación de inicio de Windows - Restablecimiento de inicio de sesión",
    sistemas: "PC-Notebook-AIO",
    freelance: 18000,
    local: 28868,
  },
  {
    tipo: "Armar PC Básica desde 0",
    sistemas: "PC-Notebook-AIO",
    freelance: 20657,
    local: 32076,
  },
  {
    tipo: "Armar PC gamer desde 0",
    sistemas: "PC-Notebook-AIO",
    freelance: 33199,
    local: 38491,
  },
  {
    tipo: "Cambio de componente Hardware x1",
    sistemas: "PC-Notebook-AIO",
    freelance: 9591,
    local: 11227,
  },
  {
    tipo: "Limpieza de Hardware + Cambio de pasta térmica",
    sistemas: "PC-Notebook-AIO-Consolas",
    freelance: 21026,
    local: 24057,
  },
  {
    tipo: "Limpieza de Hardware + Cambio de pasta térmica",
    sistemas: "PC-Notebook-AIO-Consolas",
    freelance: 21026,
    local: 28868,
  },
  {
    tipo: "Cambio de Flex",
    sistemas: "PC-Notebook-AIO",
    freelance: 17706,
    local: 19246,
  },
  {
    tipo: "Cambio de pantalla",
    sistemas: "Notebook-iPads",
    freelance: 14755,
    local: 19246,
  },
  {
    tipo: "Cambio de teclado",
    sistemas: "Notebook",
    freelance: 9222,
    local: 20849,
  },
  {
    tipo: "Despiece - Cambio de componentes internos",
    sistemas: "PC-Notebook-AIO",
    freelance: 14017,
    local: 25661,
  },
  {
    tipo: "Hard Reset + Configuración de tablets - celulares - iPads",
    sistemas: "Tablets-Celulares",
    freelance: 14017,
    local: 16038,
  },
  {
    tipo: "Configuración de Router / Access Point In Site",
    sistemas: "Red",
    freelance: 16599,
    local: 19246,
  },
  {
    tipo: "Reflow Hardware-Mother",
    sistemas: "Hardware",
    freelance: 29510,
    local: 38491,
  },
  {
    tipo: "Cambio de pin de carga",
    sistemas: "Notebook",
    freelance: 22132,
    local: 25661,
  },
  {
    tipo: "Instalación de Juegos Playstation 3",
    sistemas: "Consola-Playstation3",
    freelance: 3000,
    local: 0,
  },
  {
    tipo: "Instalación de Tienda con 2000 juegos Playstation 3",
    sistemas: "Consola-Playstation3",
    freelance: 20000,
    local: 0,
  },
];

const Reparaciones = () => {
  return (
    <motion.div
      initial="initial"
      whileInView="animate"
      viewport={{ once: true, amount: 0.2 }}
      transition={{ staggerChildren: 0.2 }}
      className="repaircontainer"
    >
      <motion.div variants={animationVariants.fadeIn}>
        <h1 className="tituloreparaciones">Precios de Reparaciones</h1>
      </motion.div>
      <div className="tablecontainer">
        <motion.table variants={animationVariants.fadeUp}>
          <thead>
            <tr>
              <th>Tipo de Arreglo</th>
              <th>Tipo de Sistemas</th>
              <th>Freelance</th>
              <th>Taller Local</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td>{item.tipo}</td>
                <td>{item.sistemas}</td>
                <td>${item.freelance}</td>
                <td>${item.local}</td>
              </tr>
            ))}
          </tbody>
        </motion.table>
      </div>
      <motion.div className="textcontent" variants={animationVariants.fadeUp}>
        <p className="textos">
          Listado de precios actualizados a MARZO del 2024 en la zona de CÓRDOBA
          - JESÚS MARÍA - COLONIA CAROYA
        </p>
        <p className="textos">
          La diferencia de Local a Freelance, es por la carga impositiva de
          tener un local a la calle y quizá empleados a cargo, lo cual encarece
          costos, pero a su vez en muchos casos brinda mayor tranquilidad al
          cliente
        </p>
      </motion.div>
    </motion.div>
  );
};

export default Reparaciones;
